module.exports = __webpack_public_path__ + "static/media/v.a1e19b2c.svg";